import { Modal } from '@eventbrite/eds-modal';
import classNames from 'classnames';
import React from 'react';
import './TakeoverDialog.scss';

export interface IToSDialogProps {
    dataTestId?: string;
    isShown: boolean;
    onClose: () => void;
    children: React.ReactElement;
    containerClasses?: string;
}

const MODAL_BODY_SELECTOR = '.eds-modal__body';

const TakeoverDialog = ({
    dataTestId = 'takeover',
    onClose,
    isShown,
    children,
    containerClasses,
}: IToSDialogProps) => {
    const componentRef = React.useRef(null);
    const tosContentRef = React.useRef(null);

    const [isInsideModal, setIsInsideModal] = React.useState<boolean>(false);
    const [shouldShowContent, setShouldShowContent] =
        React.useState<boolean>(isShown);

    React.useEffect(() => {
        const modalContent = componentRef.current;

        if (modalContent) {
            const parentModal = (modalContent as HTMLElement).closest(
                MODAL_BODY_SELECTOR,
            );

            setIsInsideModal(!!parentModal);
        }
    }, []);

    React.useEffect(() => {
        const isInsideModalAndShowsContent = isShown && isInsideModal;
        const _shouldShowContent =
            !isInsideModal || isInsideModalAndShowsContent;

        setShouldShowContent(_shouldShowContent);
    }, [isShown, isInsideModal]);

    React.useEffect(() => {
        const modalContent = componentRef.current;

        if (modalContent && isInsideModal) {
            const parentModal = (modalContent as HTMLElement).closest(
                MODAL_BODY_SELECTOR,
            );

            if (parentModal) {
                if (isShown) {
                    const tosContent = tosContentRef.current;

                    if (tosContent) {
                        const minHeight = (
                            tosContent as HTMLElement
                        ).getClientRects()?.[0]?.height;
                        const minWidth = (
                            tosContent as HTMLElement
                        ).getClientRects()?.[0]?.width;

                        (
                            parentModal as HTMLElement
                        ).style.minHeight = `${minHeight}px`;
                        (
                            parentModal as HTMLElement
                        ).style.minWidth = `${minWidth}px`;
                    }
                } else {
                    (parentModal as HTMLElement).style.minHeight = 'auto';
                    (parentModal as HTMLElement).style.minWidth = 'auto';
                }
            }
        }
    }, [isShown, shouldShowContent, isInsideModal]);

    let Wrapper = Modal;
    let modalProps: any = {
        noMinHeight: true,
        isShown,
        onClose,
    };
    const tosModalClasses = classNames('takeover-modal', {
        'takeover-modal--inside-modal': isInsideModal,
    });

    if (isInsideModal) {
        Wrapper = React.Fragment;
        modalProps = {};
    }

    return (
        <div
            ref={componentRef}
            className={tosModalClasses}
            data-testid={dataTestId}
        >
            <Wrapper {...modalProps}>
                {shouldShowContent && (
                    <div className="takeover-modal__content">
                        {/* Needed to allow the content to be absolute but still get the size for the form */}
                        <div ref={tosContentRef} className={containerClasses}>
                            {children}
                        </div>
                    </div>
                )}
            </Wrapper>
        </div>
    );
};

export default TakeoverDialog;
